<template>
  <div v-editable="blok">
    <iframe v-if="src" id="sim_8016324255_1" width="100%" frameborder="0" :src loading="lazy" />
  </div>
</template>

<script lang="ts" setup>
  const { blok } = defineProps<{ blok: MarketingNewsletterIframeStoryblok }>();

  const src = computed(() => blok.src);

  useHead({
    script: [
      {
        type: 'text/javascript',
        innerHTML: `
          window.addEventListener('message', function(e) {   var iframe = document.getElementById(e.data[2]);   var eventName = e.data[0];   switch(eventName) {     case 'setHeight':       iframe.height = e.data[1];       break;   } }, false);
        `,

      },
    ]
  });
</script>
